;(function() {
    console.log('%cSTOP!', 'font-size:48px; color: red; font-weight: bold;');
    console.log(
        '%cIf someone asked you to paste a code here - it could be a scam. ' +
        'Do not copy and paste anything into the developer console.',
        'font-size:20px; color: red; font-weight: bold;'
    );

    try {
        Object.defineProperty(console, '_commandLineAPI', {
            get() { throw new Error('The console is disabled for security reasons.'); }
        });
    } catch (e) {
    }

    let isOpen = false;
    const threshold = 160;
    setInterval(() => {
        const widthDiff  = window.outerWidth  - window.innerWidth  > threshold;
        const heightDiff = window.outerHeight - window.innerHeight > threshold;
        if ((widthDiff || heightDiff) && !isOpen) {
            isOpen = true;
            console.clear();
            console.log(
                '%cWARNING! The console is open. Do not insert any extraneous code here!',
                'font-size:20px; color: orange; font-weight: bold;'
            );
        }
        if (!(widthDiff || heightDiff)) {
            isOpen = false;
        }
    }, 500);
})();